import { Fragment, useEffect } from "react";
import { Navigate } from "react-router-dom";

import "./LegalDocument.css";
import { LegalBlock, getLegalDocument } from "./legalDocuments";

interface LegalDocumentProps {
  slug: string;
}

const renderText = (text: string) =>
  text.split("\n").map((line, index, lines) => (
    <Fragment key={`${line}-${index}`}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </Fragment>
  ));

const LegalDocument = ({ slug }: LegalDocumentProps) => {
  const document = getLegalDocument(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!document) {
    return <Navigate to="/mentions-legales" replace />;
  }

  const content = document.blocks.reduce<JSX.Element[]>((elements, block, index, blocks) => {
    if (block.type === "listItem") {
      if (index > 0 && blocks[index - 1].type === "listItem") {
        return elements;
      }

      const items: LegalBlock[] = [];
      for (let itemIndex = index; itemIndex < blocks.length; itemIndex += 1) {
        if (blocks[itemIndex].type !== "listItem") break;
        items.push(blocks[itemIndex]);
      }

      elements.push(
        <ul key={`list-${index}`}>
          {items.map((item, itemIndex) => (
            <li key={`${item.text}-${itemIndex}`}>{renderText(item.text)}</li>
          ))}
        </ul>
      );

      return elements;
    }

    if (block.type === "title") {
      elements.push(<h1 key={index}>{block.text}</h1>);
      return elements;
    }

    if (block.type === "heading") {
      elements.push(<h2 key={index}>{block.text}</h2>);
      return elements;
    }

    elements.push(<p key={index}>{renderText(block.text)}</p>);
    return elements;
  }, []);

  return <main className="legal-document">{content}</main>;
};

export default LegalDocument;
